import { useCallback, useState } from "react";

/*
A single state bag for a form, instead of one useState per input.

Deliberately minimal - no validation or dirty tracking.
*/
export default function useFormState(initial) {
  const [values, setValues] = useState(initial);

  const setField = useCallback(function (key, value) {
    setValues(function (previous) {
      return { ...previous, [key]: value };
    });
  }, []);

  const reset = useCallback(
    function () {
      setValues(initial);
    },
    [initial],
  );

  return { values, setField, setValues, reset };
}
